/** parse px to number */
export var pxToNumber = function (style) {
    if (style === void 0) { style = ''; }
    return parseFloat(style);
};
